export const FETCH_UPLOADS = 'FETCH_UPLOADS';
export const PUSH_UPLOADS = 'PUSH_UPLOADS';
export const REMOVE_UPLOADS = 'REMOVE_UPLOADS';
export const UPDATE_UPLOADS = 'UPDATE_UPLOADS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchUploads(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_UPLOADS,
      payload:data
    });
  }
}

export function pushUploads(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_UPLOADS,
      payload:data
    });
  }
}

export function removeUploads(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_UPLOADS,
      payload:data
    });
  }
}

export function updateUploads(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_UPLOADS,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActiveUploads(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
